export function valueOrSlug(value) {
  if (value) {
    if (typeof value === "string") {
      return value;
    } else {
      return value.slug;
    }
  }
}

// Takes a value such as '1-1', '-' or '1-' and returns a range settings object
export const getRangeValues = (value) => value && value.indexOf('-') > -1
  ? ({ val: value, min: value.split('-')[0], max: value.split('-')[1] })
  : ({ val: null , min: null               , max: null})

// A refined facet is one that isn't one of our "core" facets...
// @TODO: Could probably make this more reliable by moving to
// RefinementSearchForm.js or adding a callback hook? Either way it's
// either a really good definition or really bad, im just not sure yet.
export const isRefinedFacet = key => !['location', 'suburb', 'keywords', 'classification', 'price', 'radius'].includes(key)
